import { initBehaviors } from '../';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

import imagesLoaded from 'imagesloaded';

const classes = {
  bottom: 'flower--bottom',
  flip: 'flower--flip',
  leftSmall: 'flower--left-small',
  right: 'flower--right',
  rightSmall: 'flower--right-small',
  top: 'flower--top'
};

export class FlowerContainer extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.pickFlowers();

    imagesLoaded(this.element, () => {
      this.addFlowers();
    });
  }

  pickFlowers() {
    const { template } = this.refs;

    if (template) {
      const parser = new DOMParser();
      const templateDocument = parser.parseFromString(template.innerHTML, 'text/html');
      this.flowers = templateDocument.querySelectorAll('svg');
    }
  }

  pickRandomFlower() {
    const index = Math.floor(Math.random() * this.flowers.length);
    return this.flowers[index].cloneNode(true);
  }

  addFlowers() {
    const { wrapper } = this.refs;
    const containerHeight = this.element.offsetHeight;
    const numberOfFlowers = Math.floor(containerHeight / 750);
    const startingSide = Math.round(Math.random());

    for (let i = 0; i < numberOfFlowers; i++) {
      const flower = this.pickRandomFlower();
      let percentageTop;

      if ((i + startingSide) % 2 === 0) {
        flower.classList.add(classes.flip);
      } else {
        flower.classList.add(classes.right);
      }

      if (i === 0) {
        flower.classList.add(classes.top);
      } else if (i === numberOfFlowers - 1) {
        flower.classList.add(classes.bottom);
      } else {
        percentageTop = (100 / (numberOfFlowers - 1)) * i;
        flower.style.top = percentageTop + '%';
      }

      if (flower.getAttribute('class').indexOf('small') > -1) {
        if (flower.getAttribute('class').indexOf(classes.right) > -1) {
          flower.classList.add(classes.rightSmall);
        } else {
          flower.classList.add(classes.leftSmall);
        }
      }

      if (wrapper) {
        wrapper.appendChild(flower);
      }
    }

    // Dispatch reveal items added listener
    dispatchEvent(window, events.REVEAL_ITEMS_ADDED);

    // Init any behaviors on flowers
    initBehaviors(wrapper);
  }
}